import { useUserProtectionTokens } from "./user-protection-tokens/use-user-protection-tokens";
import { hasAnyAccess, ProtectionTokenCode } from "./has-any-access";

/**
 * Есть ли по праву доступ хоть к кому-нибудь. Спрашивают этим там, где записи нет и уровень
 * взять неоткуда: меню, вход на страницу, форма создания. Внутри карточки записи вопрос другой —
 * его задают через `useAbility`, который читает уровень напротив самой записи.
 */
export function useHasAnyAccess(token: ProtectionTokenCode) {
  const { tokens } = useUserProtectionTokens();

  return hasAnyAccess(tokens, token);
}
